import { fetchApi } from '@/config/axiosSetting';
import { GetBodyPreviousCorrectiveImagesType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyPreviousCorrectiveImages/getBodyPreviousCorrectiveImages.type';
import { BodyGetPreviousCorrectiveImageResponse } from '@/modules/adjusterReportModules/Insurer-information/types/Bodyimages';

export const getBodyPreviousCorrectiveImagesFunction = (
  params: GetBodyPreviousCorrectiveImagesType,
): Promise<BodyGetPreviousCorrectiveImageResponse> => {
  return fetchApi.get(
    `/body/reports/${params.id}/images/corrective/request/list/`,
  );
};
